import { api } from '../../../index';
import { Account } from '@7chairs/types';

import {
  SignUpUserResponse,
  AssignToGroupResponse,
  DiscoveryObject,
  SignUpData,
  AssignToGroupData,
  DiscoveryDoneResponse,
  UpdateAccountProfileParams,
  UpdateAccountAfterQuizParams,
} from '../../types/UserDiscoveryResponse.types';
import { QuoraConversionEvent } from '../../types/useQuora.types';

export const updateDiscoveryDone = async (discovery: DiscoveryObject): Promise<DiscoveryDoneResponse> => {
  return await api.post<DiscoveryDoneResponse>('signup/funnel/step', discovery);
};

export const canUserSignUp = async (url: string): Promise<any> => {
  return await api.get<any>(`signup/can-signup?${url}`);
};

export const checkIfEmailExists = async (email: string): Promise<any> => {
  return await api.get<any>(`signup/email-exists?email=${email}`);
};

export const signUpUser = async (data: SignUpData): Promise<SignUpUserResponse> => {
  return await api.post<SignUpUserResponse>('signup/lead', data, true);
};

export const assignToGroup = async (data: AssignToGroupData): Promise<AssignToGroupResponse> => {
  return await api.post<AssignToGroupResponse>('/account/assign-to-group', data);
};

export const updateAccountProfile = async (params: UpdateAccountProfileParams): Promise<any> => {
  return await api.patch<any>('/account/v2/profile', {
    planLabelIds: params.planLabelIds,
    voicesSegments: params.voicesSegments,
  });
};

export const updateAccountAfterQuiz = async (params: UpdateAccountAfterQuizParams): Promise<any> => {
  return await api.patch<any>('/account/profile-after-quiz', params);
};

export const getUser = async (): Promise<Account> => {
  return await api.get<Account>('/account');
};

export const userReDiscovery = async (discovery: DiscoveryObject): Promise<DiscoveryDoneResponse> => {
  return await api.post<DiscoveryDoneResponse>('account/re-discovery', discovery);
};

export const sendQuoraConversionEvent = async (quoraConversionEvent: QuoraConversionEvent): Promise<any> => {
  return await api.post<DiscoveryDoneResponse>('signup/quora-conversion-event', quoraConversionEvent);
};
